// extracted by mini-css-extract-plugin
export default {"form":"styles_form__hrK1i","form_title":"styles_form_title__WP4tF","form_fields":"styles_form_fields__7jcgZ"};